// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__bf1yM","title":"header_title__4GtYq","subTitle":"header_subTitle__1gtFs","video":"header_video__Fu0gh","imageWrapper":"header_imageWrapper__48_mj"};